import {
    CartCreatorType,
    CardTypeSpecified,
    ProductType,
    VoucherType,
} from 'store/api-slice/types'

export const SESSION_TYPE_MARCH_PROMO = 'marchpromo'

export const CART_TYPE_STANDARD: CartCreatorType = 'standard'
export const CART_TYPE_ACCOMMODATION: CartCreatorType = 'accommodation'
export const CART_TYPE_CARD: CartCreatorType = 'card'
export const CART_TYPE_CARD_RENEW: CartCreatorType = 'card-renew'
export const CART_TYPE_VOUCHER: CartCreatorType = 'voucher'

export const PRODUCT_TYPE_TICKET: ProductType = 'ticket'
export const PRODUCT_TYPE_SPA: ProductType = 'spa_treatment'
export const PRODUCT_TYPE_BUS_TICKET: ProductType = 'bus_ticket'
export const PRODUCT_TYPE_CABANA: ProductType = 'cabana'
export const PRODUCT_TYPE_ACCOMMODATION: ProductType = 'accommodation'
export const PRODUCT_TYPE_CARD: ProductType = 'card'
export const PRODUCT_TYPE_VOUCHER: ProductType = 'voucher'
export const PRODUCT_TYPE_PARKING: ProductType = 'parking'
export const PRODUCT_TYPE_BUNDLE: ProductType = 'bundle'
export const PRODUCT_TYPE_SHIPPING: ProductType = 'shipping'

export const PRODUCT_NAME_CARD = 'unlimited'

export const PRODUCT_ID_MARCH_VOUCHER_STANDARD =
    '51e056b2-3050-482b-94d1-b6d183f8b624'
export const PRODUCT_ID_MARCH_VOUCHER_PROLONGED =
    'b77dac88-5819-4c4b-bd5a-6bd40a9e3562'
export const PRODUCT_ID_MARCH_VOUCHER_SELFCARE =
    '480c99c4-ae36-414c-9df6-3faa81db2b57'

export const PRODUCT_ID_CITY_BREAK_TICKET_TEENAGER =
    '9cae51bc-693f-401a-8592-b0f722db871f'
export const PRODUCT_ID_CITY_BREAK_TICKET_ADULT =
    'aa093f19-09a0-4137-a361-53be5cafaf63'

export const CARD_TYPE_UNLIMITED_BUNDLE: CardTypeSpecified = 'unlimited_bundle'
export const CARD_TYPE_UNLIMITED_BUNDLE_PLUS: CardTypeSpecified =
    'unlimited_plus_bundle'

export const VOUCHER_TYPE_AMOUNT: VoucherType = 'amount'
export const VOUCHER_TYPE_PRODUCT: VoucherType = 'product'
